import * as types from '../types';
import adminApi from '../../apis/admin';

export const startLoading = () => (dispatch) => dispatch({ type: types.GLOBAL_START_LOADING });

export const stopLoading = () => (dispatch) => dispatch({ type: types.GLOBAL_STOP_LOADING });

export const onPost = ({ url, body }: { url: string; body: any }) => async (dispatch): Promise<any> => {
  dispatch({ type: types.GLOBAL_START_LOADING });
  try {
    const { data } = await adminApi.post(url, { ...body });
    dispatch({ type: types.GLOBAL_STOP_LOADING });
    return data;
  } catch (error) {
    dispatch({ type: types.GLOBAL_STOP_LOADING });
    return null;
  }
};

export const onGet = ({ url, body = {}, global = true }: { url: string; body: any, global: boolean }) => async (dispatch): Promise<any> => {
  if (global) dispatch({ type: types.GLOBAL_START_LOADING });
  try {
    const { data } = await adminApi.get(url, { params: { ...body } });
    if (global) dispatch({ type: types.GLOBAL_STOP_LOADING });
    return data;
  } catch (error) {
    if (global) dispatch({ type: types.GLOBAL_STOP_LOADING });
    return null;
  }
};

export const onGetCD = ({ url, body = {}, global = true }: { url: string; body: any, global: boolean }) => async (dispatch): Promise<any> => {
  if (global) dispatch({ type: types.GLOBAL_START_LOADING });
  try {
    const { data } = await adminApi.get(url, { params: { ...body } });
    if (global) dispatch({ type: types.GLOBAL_STOP_LOADING });
    return data;
  } catch (error) {
    if (global) dispatch({ type: types.GLOBAL_STOP_LOADING });
    throw error;
  }
};
